import React from "react";
import { resolveImageUrl } from "@/utils/constants";

interface PromotionModalCardProps {
  id: number;
  title: string;
  img: string;
  onNavigate?: (id: number) => void; // callback to navigate
}

const PromotionModalCard: React.FC<PromotionModalCardProps> = ({
  id,
  title,
  img,
  onNavigate,
}) => {
  return (
    <div
      onClick={() => {
        if (onNavigate) {
          onNavigate(id); // trigger navigation via parent
        }
      }}
      className="
        bg-white dark:bg-surfaceWebGrey
        aspect-[2/1]
        min-w-[250px] max-w-[250px]
        rounded-xl
        overflow-hidden
        cursor-pointer
        shadow-lg
        flex flex-col
      "
    >
      <img
        className="w-full h-[140px] object-cover"
        src={resolveImageUrl(img)}
        alt={`${id}_img`}
        draggable={false}
      />
      <div className="p-2">
        <div className="text-black dark:text-textAdditional font-bold text-[17px] leading-snug">
          {title}
        </div>
      </div>
    </div>
  );
};

export default PromotionModalCard;
